<template>
  <div class="home">
    <div class="main-content" v-if="isMaxScreen">
      <el-dialog
        :title="$t('component.btnDialog.64a9shqq2ks0')"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <span>{{$t('component.btnDialog.64a9shqq3k00')}}</span>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">Confirm cancel</el-button> -->
          <el-button type="primary" @click="confirm">Confirm cancel</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="main-content" v-else>

      <van-dialog v-model="dialogVisible" :title="$t('component.btnDialog.64a9shqq2ks0')" :show-confirm-button="false" close-on-click-overlay>
        <p>{{$t('component.btnDialog.64a9shqq3k00')}}</p>
        <div class="btn-box">
          <!-- <van-button class="btn1" @click="confirm">Confirm cancel</van-button> -->
          <van-button class="btn2" @click="confirm">{{ $t('component.btnDialog.sureCancel') }}</van-button>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { orderReject } from '../../../services/api/brandList.js'
export default {
  name: 'btnDialog',
  components: {
  },
  props: {
    isCenter:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
    handleClose(){

    },
    close(){
      this.dialogVisible = false
    },
    confirm(){
      orderReject()
        .then((res) => {
          if(res.code == '0000'){
            this.$toast(this.$t('component.btnDialog.64a9shqq3r00'));
            window.location.reload();
            this.dialogVisible = false
          }
        })
        .catch(() => {
          this.$toast(this.$t('component.btnDialog.64a9shqq3ws0'));
        });
    }
  }
}
</script>
<style scoped lang="less">
@media (max-width: 980px) {

  p{
    color: var(---Text-2, #5D5F65);
    font-family: "PingFang SC";
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    margin: 32px 44px 52px;
  }

  .btn-box{
    display: flex;
    justify-content: space-between;
    margin: 32px 44px;
  }

  .btn1{
    display: flex;
    flex: 1;
    height: 88px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    margin-right: 16px;
    border-radius: 10px;
    background: #F5F6F9;
    color: var(---Text-1, var(---Text-1, #252629));
    border: none;
  }

  .btn2{
    display: flex;
    flex: 1;
    height: 88px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 10px;
    background: var(---Brand-1, #405FFF);
    color: #fff;
    border: none;
  }




}
@media (min-width: 981px) {

}
</style>
